import React from "react";
import { omit } from "lodash";
import { Location } from "@reach/router";
import Layout from "./src/layouts/index";
import SecurityProvider from "./src/components/security-provider";
import { ProvideTargetContext } from "./src/target-context";
import OrderingHome from "./src/templates/index";

export default ({ element, props }) => {
  const pageContext = props.pageContext || {};
  const target = pageContext.target || 'ordering';

  // Set pageContext on window for components that need it before React renders
  if (typeof window !== 'undefined' && pageContext.business) {
    window.pageContext = pageContext;
  }
  const pathname = props.location?.pathname || '';

  // Return element without Layout wrapper for 404 pages or pages missing required context
  if (
    props.custom404 ||
    pageContext.is404Page ||
    element.key === "/404.html" ||
    pathname === "/404.html" ||
    pathname === "/404/" ||
    pathname === "/404" ||
    !pageContext.business
  ) {
    return element;
  }

  const businessAppConfiguration = pageContext.businessAppConfiguration || {};
  const { recaptchaKey, captchaProvider, hcaptchaKey } = businessAppConfiguration;

  const layoutProps = omit(props, "data");


  return (
    <ProvideTargetContext target={target}>
      <Location>
        {({ location }) => (
          <SecurityProvider
            recaptchaKey={recaptchaKey}
            hcaptchaKey={hcaptchaKey}
            captchaProvider={captchaProvider}
          >
            <Layout {...layoutProps} location={location}>
              {element}
            </Layout>
          </SecurityProvider>
        )}
      </Location>
    </ProvideTargetContext>
  );
};
